import type { WorkspaceState } from '../context';
import { emptyTurnContext } from '../types';
import { NEW_AGENT_CANVAS } from './new-agent';

/** Home and Agents open the same New agent chat: nothing is sent; the person
 * describes the agent, and its draft takes shape in the canvas beside it. */
export function beginAgentCreation(workspace: Pick<WorkspaceState, 'send'>) {
  workspace.send('', { ...emptyTurnContext(), newAgent: true }, false, NEW_AGENT_CANVAS, {
    newChat: true,
  });
}
